<template>
<div>
	<Loader :show="loading"></Loader>

	<div class="fullscreen" >
		<div class="head ">
			<div class="container">
				<div class="btn icon icon-close invert" @click="$router.push('/')" ></div>
				<h1>Cerrar traslado</h1>
			</div>
		</div>

		<div class="content">
			<div class="container">

				<div>

					<div class="d-flex align-items-end position-relative">

						<b-form-group label="Número de Chasis" class="mt-4 flex-grow-1">
							<b-form-input
								v-model="form.chassis_number"
								placeholder="Ingrese el número de chasis del vehículo del traslado"
								:state="!validation.hasError('form.chassis_number')" 
							></b-form-input>
							<b-form-invalid-feedback>Ingrese el número de chasis del vehículo del traslado</b-form-invalid-feedback>
						</b-form-group>

						<div @click="searchCars()" class="btn ml-1 btn-find">
							<i class="fa fa-search"></i>
						</div>
						
						<div @click="scanCar()" class="btn ml-1 btn-scan">
							<i class="fa fa-qrcode"></i>
						</div>

						<div class="selectable" v-if="showSelectable">
							<table class="table mt-2 mb-4" v-if="cars.length>0">
								<tr class="table-head">
									<td>Chasis</td>
									<td>Vehículo</td>
								</tr>
								<tr v-for="item of cars" :key="item.id" @click="selectCar(item)">
									<td>{{item.chassis_number}}</td>
									<td>
										<div class="tc">
											<span v-if="item.brand && !item.brand.title">{{item.brand}}</span>
											<span v-if="item.brand.title">{{item.brand.title}}</span>
											<span >{{item.model}}</span>
										</div>
									</td>
								</tr>
							</table>
							<div class="alert alert-warning mt-2" v-if="cars.length==0">
								No se han encontrado vehículos con el chasis ingresado
							</div>
						</div>
						<div v-if="showSelectable" class="selectable-backdrop" @click="showSelectable=false">

						</div>

					</div>



					<b-form-group label="Lugar de entrega" class="mt-4">
						<v-select
							taggable
							v-model="form.location"
							:options="locations"
							:clearable="false"
							class="v-select"
							
						/>
						<b-form-invalid-feedback :state="!validation.hasError('form.location')" >Ingrese el lugar de entrega</b-form-invalid-feedback>
					</b-form-group>	
					
					
					<b-form-group label="Firma" class="mt-4 mb-4">
						<div class="invalid-feedback d-block" v-if="validation.hasError('form.signature')">Ingrese la firma</div>					
						<SignatureInput v-model="form.signature"></SignatureInput>
					</b-form-group>

					<b-form-group label="Aclaración" class="mt-4">
						<b-form-input
							v-model="form.signatureClarification"
							placeholder="Ingrese la aclaración de la firma."
							:state="!validation.hasError('form.signatureClarification')" 
						></b-form-input>
						<b-form-invalid-feedback>Ingrese la aclaración de la firma.</b-form-invalid-feedback>
					</b-form-group>


					<b-form-group label="Comentarios" class="mt-4">
						<textarea-autosize
						placeholder="Comentarios"
						v-model="form.comments"
						:min-height="30"
						:max-height="350"
						class="form-control"
						/>
					</b-form-group>

				</div>
				
			</div>
		</div>
		<div class="footer" >
			<div class="container">
				<div class="btn btn-block btn-primary" @click="save()">
					Cerrar traslado
				</div>
			</div>
		</div>
	</div>

	<ReadCode ref="readCarCode" @readed="chassisReaded" />
	
</div>
</template>


<script>
import gql from 'graphql-tag'
import mixins from '@/mixins/mixins'
import Loader from '@/components/Loader'
import SignatureInput from '@/components/SignatureInput'
import ReadCode from './ReadCode'

import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;

export default {
	name: 'TransferEnd',
	mixins:[mixins],
	components: {
		Loader,
		SignatureInput,
		ReadCode
	},
	data(){
		return{
			API_URL: process.env.VUE_APP_API_URL,
			loading: false,
			brands:[],
			showSelectable: false,
			touched :false,
			cars: [],

			form:{
				chassis_number: null,
				location: null,
				signature: null,
				comments: null,
			},
			locations:['Rondeau', 'CarOne', 'Carrasco', 'Chevrolet Montevideo', 'Shopping de autos','Emancipación', 'Lync & Co']
			// locations:['Rondeau', 'Propios', 'Carrasco', 'Chevrolet Montevideo', 'Galicia','Emancipación']
		}
	},
	validators: {
		'form.chassis_number': function (value) {
			return Validator.value(value).required();
		},
		'form.location': function (value) {
			return Validator.value(value).required();
		},
		'form.signature': function (value) {
			return Validator.value(value).required();
		},
		'form.signatureClarification': function (value) {
			return Validator.value(value).required();
		},
	},
	
	methods:{

		scanCar(){
			this.$refs.readCarCode.open()
		},
		chassisReaded(chassis_number){
			// busco el auto entre los traslados en curso.
			this.loading = true
			this.$apollo.query({
				query: gql`query ($chassis_number: String!, $status: String!) {
					transfer (chassis_number: $chassis_number, status: $status) {
						id
						chassis_number
					}
				}`,
				variables: {
					chassis_number: chassis_number,
					status: 'ON_COURSE',
				},
				fetchPolicy: 'no-cache'
			})
			.then(({data}) => {
				if(!data.transfer){
					this.$toast.error('No se ha encontrado un vehículo con ese código con traslado abierto')
				}else{
					console.log(data.transfer)
					
					this.form.chassis_number = data.transfer.chassis_number

				}
				this.loading = false
			})
		},
		

		searchCars(){
			if(this.form.chassis_number){
				this.touched = true
				this.loading = true

				this.$apollo.query({
					query: gql`query ($first: Int!, $page: Int, $chassis_number: String!) {
						transfers (first: $first, page: $page, chassis_number: $chassis_number) {
							data{
								id
								chassis_number
								brand
								model
								color
							}
						}
					}`,
					variables: {
						page: 0,
						first: 10,
						chassis_number: this.form.chassis_number,
					},
					fetchPolicy: 'no-cache'
				})
				.then(({data}) => {
					this.loading = false
					this.cars = data.transfers.data
					this.showSelectable = true
				})
			}
		},

		selectCar(car){
			this.form.chassis_number = car.chassis_number
			this.showSelectable = false
			
		},

		async save(){
			if(!this.loading && await this.checkValidation() ) {
				this.loading = true
				let dataInput = {
					type: 				'CHECKIN',
					chassis_number: 	this.form.chassis_number,
					location: 			this.form.location,
					signature: 			this.form.signature,
					signatureClarification: this.form.signatureClarification,
					comments: 			this.form.comments,
				}
				this.$apollo.mutate({
					mutation: gql`mutation ( $data:ControlTransferEndInput! ){
						controlTransferEnd( data: $data) {
							id
						}
					}`,
					variables: {
						data: dataInput
					}
				})
				.then((data) => {
					this.controlCreated = data.data.controlTransfer
					this.$toast.success('Traslado cerrado correctamente')
					this.$router.push('/')
				})
				.catch( (error) => {
					this.parseGQLErrors(error)
					this.loading = false
				})
			}
		}
	}
	
}
</script>

<style scoped>
.selectable{
	width:410px;
    position: absolute;
	top: 80px;
    left: 5px;
    background: #fff;
    z-index: 1000;
	border-radius: 0px 0px 4px 4px;
    padding: 8px;
	-webkit-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
	-moz-box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
	box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.33);
}
.selectable-backdrop{
	width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    right: 0px;
    position: fixed;
    background: #f3f3f350;
    bottom: 0px;
    z-index: 10;
}

.btn-scan{
	height: 38px;
    border-radius: 4px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background: #28a745;
    border: #28a745;
    color: #fff;
}
.btn-find{
	height: 38px;
    border-radius: 4px;
    font-size: 22px;
    display: flex;
    align-items: center;
    background: #28a745;
    border: #28a745;
    color: #fff;
}
</style>
